import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { DateService } from '@/coreDomainsModule/services/dateService';
import {
  OrderBasisNextDailyInfo,
  OrderBasisNextMonthlyInfo,
  OrderBasisPastMonthlyInfo,
  OrderBasisRequestInfo,
  UpsertAndSingleSimulationOrderRequestInfo,
  UpsertOrderInfo,
} from '@/coreInfrastructureModule/axios/generated/orderManage';
import { DisplayIArrival } from '@/recommendOrderModule/pages/interfaces/displayIArrival';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class upsertAndSingleSimulationOrderAdapter {
  /**
   * フロント側の発注情報の型、IAnnounceからBulkPostOrderResponseInfoに変換を行う
   * FIXME: Listに対してadaptするのやめてほしい（単体でやりたい）
   * @param registerOrderInfo - 登録を行う発注情報
   * @param aggregateBusinessId - 集計ID
   * @param orderBasisInfo - 発注根拠情報
   */
  public static requestAdapter = (
    registerOrderInfo: DisplayIArrival,
    aggregateBusinessId: string,
    orderBasisInfo: IOrderBasis
  ): UpsertAndSingleSimulationOrderRequestInfo => {
    const crossDate = registerOrderInfo.crossDate ? DateService.convertIDateToDate(registerOrderInfo.crossDate) : new Date();
    const adaptedOrderInfo: UpsertOrderInfo = {
      orderId: registerOrderInfo.arrivalId,
      desiredDeliveryDate: DateService.formatDateToISOString(crossDate), // 希望納期
      estimatedTimeOfArrival: DateService.formatDateToISOString(crossDate), // 納期
      orderAmount: registerOrderInfo.amount,
      orderStatus: registerOrderInfo.status ? registerOrderInfo.status : 'Recommended',
      orderNote: registerOrderInfo.memoText,
    };
    const adaptedOrderBasisInfo: OrderBasisRequestInfo = {
      snapshotLatestInventoryAmount: orderBasisInfo.snapshotLatestInventoryAmount,
      snapshotExecutionDate: orderBasisInfo.snapshotExecutionDate,
      snapshotPackage: orderBasisInfo.snapshotPackage,
      snapshotMoq: orderBasisInfo.snapshotMoq,
      userAdjustedLeadTime: orderBasisInfo.userAdjustedLeadTime.value,
      userAdjustedLeadTimeUnit: orderBasisInfo.userAdjustedLeadTime.unit,
      userAdjustedStdInventoryIndexMax: orderBasisInfo.userAdjustedStdInventoryIndex.max,
      userAdjustedStdInventoryIndexMin: orderBasisInfo.userAdjustedStdInventoryIndex.min,
      userAdjustedStdInventoryIndexUnit: orderBasisInfo.userAdjustedStdInventoryIndex.option.unit,
      nextMonthlyInfos: orderBasisInfo.nextMonthlyInfos.map(
        (nextMonthlyInfo): OrderBasisNextMonthlyInfo => ({
          orderBasisTargetYear: nextMonthlyInfo.orderBasisTargetYearMonth.year,
          orderBasisTargetMonth: nextMonthlyInfo.orderBasisTargetYearMonth.month,
          userAdjustedCustomerForecastAmount: nextMonthlyInfo.userAdjustedCustomerForecastAmount.toFixed(6),
          snapshotCustomerForecastAmount: nextMonthlyInfo.snapshotCustomerForecastAmount.toFixed(6),
          snapshotPreInventoryAmount: nextMonthlyInfo.snapshotPreInventoryAmount.toFixed(6),
          dailyInfos: nextMonthlyInfo.dailyInfos.map(
            (nextDailyInfo): OrderBasisNextDailyInfo => ({
              orderBasisTargetDay: nextDailyInfo.orderBasisTargetDay,
              snapshotArrivalAmount: nextDailyInfo.snapshotArrivalAmount.toFixed(6),
            })
          ),
        })
      ),
      pastMonthlyInfos: orderBasisInfo.pastMonthlyInfos.map(
        (pastMonthlyInfo): OrderBasisPastMonthlyInfo => ({
          orderBasisTargetYear: pastMonthlyInfo.orderBasisTargetYearMonth.year,
          orderBasisTargetMonth: pastMonthlyInfo.orderBasisTargetYearMonth.month,
          snapshotCustomerForecastAmount: pastMonthlyInfo.snapshotCustomerForecastAmount.toFixed(6),
          snapshotSalesResultAmount: pastMonthlyInfo.snapshotSalesResultAmount.toFixed(6),
        })
      ),
    };
    return {
      upsertOrderInfo: adaptedOrderInfo,
      aggregateBusinessId: aggregateBusinessId,
      displayId: registerOrderInfo.displayId,
      upsertOrderBasisInfo: adaptedOrderBasisInfo,
    };
  };
}
